import service from './request'

//查询消息提醒列表
export const getMsgTipsList = data => {
  return service({
    showLoading: true,//调用预加载
    url: '/platform/msgtips/getList',
    method: 'post',
    type: 'body',
    data
  })
};

//提醒信息置为已读
export const setMsgTipsReadFlag = data => {
  return service({
    url: '/platform/msgtips/setReadFlag',
    method: 'post',
    type: 'body',
    data
  })
};

//获取提醒未读数
export const getMsgTipsUReadCount = data => {
  return service({
    url: "/platform/msgtips/getUReadCount",
    method: "post",
    data
  });
};

//增加消息提醒
export const addInfoTips = data => {
  return service({
    showLoading: true,
    url: '/platform/msgtips/addInfo',
    method: 'post',
    type: 'body',
    data
  })
};



// WEBPACK FOOTER //
// ./src/http/MsgTips.js